/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reveal_PlantInputs */

const en_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reveal Your Tree`)
};

const ar_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكشف عن شجرتك`)
};

const de_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enthüllen Sie Ihren Baum`)
};

const es_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revela tu árbol`)
};

const fr_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Révéler mon arbre`)
};

const it_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivela il tuo albero`)
};

const ja_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`木を表示する`)
};

const ko_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나무 확인하기`)
};

const pt_br_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelar sua árvore`)
};

const ru_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите своё дерево`)
};

const th_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดเผยต้นไม้ของคุณ`)
};

const tr_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağacını Ortaya Çıkar`)
};

const zh_cn_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁专注树`)
};

const zh_tw_reveal_plant = /** @type {(inputs: Reveal_PlantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖專注樹`)
};

/**
* | output |
* | --- |
* | "Reveal Your Tree" |
*
* @param {Reveal_PlantInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const reveal_plant = /** @type {((inputs?: Reveal_PlantInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reveal_PlantInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reveal_plant(inputs)
	if (locale === "ar") return ar_reveal_plant(inputs)
	if (locale === "de") return de_reveal_plant(inputs)
	if (locale === "es") return es_reveal_plant(inputs)
	if (locale === "fr") return fr_reveal_plant(inputs)
	if (locale === "it") return it_reveal_plant(inputs)
	if (locale === "ja") return ja_reveal_plant(inputs)
	if (locale === "ko") return ko_reveal_plant(inputs)
	if (locale === "pt_br") return pt_br_reveal_plant(inputs)
	if (locale === "ru") return ru_reveal_plant(inputs)
	if (locale === "th") return th_reveal_plant(inputs)
	if (locale === "tr") return tr_reveal_plant(inputs)
	if (locale === "zh_cn") return zh_cn_reveal_plant(inputs)
	return zh_tw_reveal_plant(inputs)
});